const HubSection = ({ title, description, children, className = '' }) => (
  <section className={`h-full min-w-0 ${className}`}>
    <div className='mb-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 px-1'>
      <h3 className='text-[1rem] font-medium text-slate-800'>{title}</h3>
      {description ? <p className='text-[12px] font-normal text-slate-500'>{description}</p> : null}
    </div>
    <div className='min-h-[138px] rounded-[28px] border border-slate-200 bg-slate-50 p-4 shadow-[0_8px_20px_rgba(15,23,42,0.04)]'>
      {children}
    </div>
  </section>
)

export default HubSection
